export default __webpack_public_path__ + "static/media/doctor-image.0addc9fa.png";